/**
 * Network enum - tương ứng với backend Network enum
 * Sử dụng để phân biệt campaigns theo các blockchain network khác nhau
 */
export enum Network {
  POLYGON = 'polygon',
  BNB = 'bnb',
  ETHEREUM = 'ethereum',
  SOLANA = 'solana',
}

/**
 * Map từ chain name (frontend) sang Network enum (backend)
 * @param chain - Chain name từ frontend ('bnb' | 'solana')
 * @returns Network enum value
 */
export function mapChainToNetwork(chain: string): Network {
  switch (chain.toLowerCase()) {
    case 'bnb':
      return Network.BNB;
    case 'solana':
      return Network.SOLANA;
    case 'polygon':
      return Network.POLYGON;
    case 'ethereum':
      return Network.ETHEREUM;
    default:
      // Mặc định là POLYGON theo backend
      return Network.POLYGON;
  }
}

